import { Directive, HostListener, Input } from "@angular/core";

import { SpsModalComponent } from "../components/index";

@Directive({ selector: "[spsModalOpen]" })
export class SpsModalOpenDirective {
    @Input() spsModalOpen: string;

    @HostListener("click") onClick() {
        if (SpsModalComponent.modals.has(this.spsModalOpen)) {
            SpsModalComponent.modals.get(this.spsModalOpen).open();
        }
    }
}
